/**
 * Base Stage that configures default responsiveness, sets ticker, etc
 * @export
 * @abstract
 * @class BaseLayer
 * @extends {cc.Layer}
 */
export default class Loader {
    public static hideLoader(): void {
        const loaderDivID = "_preload_div_";
        let preloaderDiv = document.getElementById(loaderDivID);
        if (preloaderDiv) {
            preloaderDiv.style.display = "none";
        }
    }
}
